import { Injectable } from '@angular/core';
import { FormV2ElementDto } from '../dto/form-v2-element.dto';
import { FormV2ElementTypeEnum } from '../dto/form-v2-element-type.enum';

export class FormBuilderUtils {
  private static uniqueElementIds: Array<FormV2ElementTypeEnum> = [
    FormV2ElementTypeEnum.ProfileIndividual,
    FormV2ElementTypeEnum.ProfileOrganization
  ]

  public static validateElementToAdd(elementToAdd: FormV2ElementDto, elements: Array<FormV2ElementDto>): boolean {
    let valid = true;

    if (!elements || elements.length === 0) {
      return valid;
    }

    if (this.uniqueElementIds.includes(elementToAdd.ElementType)) {
      if (elements.some(x => x.ElementType === elementToAdd.ElementType)) {
        valid = false;
      }
    }

    return valid;
  }
}
